import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SdStorageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sd_storage"}/>
}
